import React from 'react';
import { Outlet } from 'react-router-dom';

const LegalLayout = () => {
    return (
        <div>
            <Outlet />
        </div>
    );
};

export default LegalLayout;
